export const environment = {
    production: '#{isproduction}#',
    name: "global",
    version: '20240506.1',
    paygateEnabled: '#{ispaygateenabled}#',
    iCBMSWebApi: {
        url: '#{icbmswebapi.url}#',
        systemCode: '#{icbmswebapi.systemcode}#',
        userData: null
    },
    consoleAPIUrl: '#{consoleapiurl}#',
    payGateApi: {
        url: '#{paygateapi.url}#',
        icbmsUrl: '#{paygateapi.icbmsurl}#',
        returnUrl: '#{paygateapi.returnurl}#'
    },
    authWebApi: {
        url: '#{authwebapi.url}#',
        client: '#{authwebapi.client}#',
        systemCode: '#{authwebapi.systemcode}#',
        userData: null,
        systemData: null
    }
    , workflowApi:
    {
        url: '#{workflowapi.url}#'

    }
    , captcha: {
        siteKey: '#{captcha.sitekey}#'
    }
    , activateLink: {
        url: '#{activatelink.url}#'
    },
    extractToView: {
        url: '#{extracttoview.url}#'
    },
    azure: {
        redirectUri: '#{azure.redirecturi}#'
    }
};
